import { create } from "zustand";

interface HeightStore {
  height: number;
}

export const useBottomNavHeightStore = create<HeightStore>(() => ({
  height: 0,
}));

export const useHeaderHeightStore = create<HeightStore>(() => ({
  height: 0,
}));

export const useChatInputHeightStore = create<HeightStore>(() => ({
  height: 0,
}));

export const useChatHeaderHeightStore = create<HeightStore>(() => ({
  height: 0,
}));

export const useMessageReplyHeightStore = create<HeightStore>(() => ({
  height: 0,
}));
